import { db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { store } from "../store/store";

export default function getProdutos(database) {
  onSnapshot(doc(db, database, "produtos"), (doc) => {
    var data = Object.values(doc.data());
    data = data[0];
    var pedidos = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i].ativado != "false") {
        pedidos.push(data[i]);
      }
    }
    store.commit("incrementProdutos", pedidos);
  });
}
